import HTTPClientCache from "./http-client_cache";

// Override `maxAge` and cache URLs with query parameters
const options = {
  cache: {
      // maxAge: 1 * 60 * 60 * 1000, // set cache time to 1 hour (instead 15 minutes)
      exclude: { query: false } // cache requests with query parameters
  }
}

class AgenciesService {
  async getAllAgencies() {
    const httpClient = new HTTPClientCache();
    const api = await httpClient.configure();
    return api.get(`/copelagencies`, options);
  }

  async getAgency(id) {
    const httpClient = new HTTPClientCache();
    const api = await httpClient.configure();
    return api.get(`/copelagency/${id}`, options);
  }

}

export default new AgenciesService();
